import { Link } from 'react-router-dom';

import { CheckOutlined } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export const StyledContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;

export const StyledLabel = styled.div`
    width: 70px;
    color: #ffffff;
    align-items: center;
    border-radius: 3px;
    margin-right: 12px;
`;

export const StyledConnectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding-left: 24px;
    @media screen and (max-width: 900px) {
        width: 70%;
    }
`;

export const StyledTwoScreensWrapper = styled.div`
    background: #fff;
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
`;

export const StyledMessageWithTipContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const StyledWidthWrapper = styled.div`
    width: 80%;
`;

export const StyledDivFormDetails = styled.div`
    display: flex;
    justify-content: space-between !important;
    margin-top: 36px;
    padding-left: 8px;
    padding-right: 8px;
`;

export const StyledDivConfig = styled.div`
    display: flex;
    justify-content: start !important;
    margin-top: 36px;
    padding-left: 8px;
    padding-right: 8px;
    gap: 88px;
`;

export const StyledLink = styled(Link)`
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-decoration-line: underline;
    color: #4c17ad;
`;

export const StyledLinkDetails = styled(Link)`
    color: #4c17ad;
    font-size: 12px;
    font-family: Inter;
    font-weight: 400;
    text-decoration: underline;
    line-height: 20px;
    word-wrap: break-word;
`;

export const StyledDivDescription = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px !important;
    justify-content: center;
`;
export const StyledDivInputs = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-left: 44px;
`;

export const StyledDivButtons = styled.div`
    display: flex;
    justify-content: end;
    gap: 8px;
    margin-top: 24px;
`;

export const StyledWidthWrapper2 = styled.div`
    width: 100%;
`;

export const ConnectionCheckContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0 20px 0 0px !important;
`;

export const ConnectionsCheck = styled(CheckOutlined)`
    font-size: 1rem !important;
    margin-right: 5px;
`;

export const ConnectionsCheckLabel = styled(Typography)`
    margin: 0 !important;
    font-size: 0.75rem !important;
`;

export const ServiceDescriptionText = styled.p`
    color: #5b5b5b;
    font-size: 14px;
    font-family: Inter;
    font-weight: 400;
    line-height: 22px;
    word-wrap: break-word;
    margin: 0px 0px 1.5625rem;
`;

export const StyledDisconnectButton = styled.button`
    width: 70px;
    height: 22px;
    font-size: 10px;
    font-family: Inter;
    color: #5b5b5b;
    border-radius: 3px;
    background-color: #ffffff;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px;
    &:hover {
        cursor: pointer;
    }
`;
